import {
    LOGIN_USER,
    LOGGING_IN_USER,
    LOGOUT_USER,
    SET_ERROR_MESSAGE,
    ADD_PRODUCTS_TO_CART,
    CLEAR_CART,
    UPDATE_CART,
    SCHOOL,
    SET_CLASS_NAME,
    SET_LANGUAGE_NAME,
    SET_CLASS_ID,
    SET_LANGUAGE_ID,
    SET_ORDER_ID,
    SET_PARENT_SCHOOLS,
    SET_UNIFORM_CATALOG
} from "./actions";

let initialState = {
    userPortalError: '',
    isStudentLogging: false,
    student: {},
    isStudentAuthenticated: false,
    products: [],
    school: '',
    className: '',
    lname: '',
    classId: '',
    langId: '',
    selectedOrderId: "",
    parentSchools: [],
    hasUniformCatalog: false,
}

function dataReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ERROR_MESSAGE:
            return { ...state, userPortalError: action.error };
        case LOGIN_USER:
            return { ...state, student: action.userData, isStudentAuthenticated: action.isAuthenticated };
        case LOGGING_IN_USER:
            return { ...state, isStudentLogging: action.status }
        case LOGOUT_USER:
            return { ...initialState };
        case SCHOOL:
            return { ...state, school: action.school };
        case SET_CLASS_NAME:
            return { ...state, className: action.className };
        case SET_LANGUAGE_NAME:
            return { ...state, lname: action.lname };
        case SET_CLASS_ID:
            return { ...state, classId: action.classId };
        case SET_LANGUAGE_ID:
            return { ...state, langId: action.langId };
        case ADD_PRODUCTS_TO_CART:
            let products = state.products;
            products = products.concat(action.products)
            return { ...state, products }
        case CLEAR_CART:
            return { ...state, products: [] }
        case UPDATE_CART:
            return { ...state, products: action.products }
        case SET_ORDER_ID:
            return { ...state, selectedOrderId: action.setSelectedOrderId };
        case SET_PARENT_SCHOOLS:
            return { ...state, parentSchools: action.schools };
        case SET_UNIFORM_CATALOG:
            return { ...state, hasUniformCatalog: action.hasUniformCatalog };
        default:
            return state;
    }
}

export default dataReducer;

export const getUserData = state => state.student;
export const getLoggingStatus = state => state.isStudentLogging;
export const getisAuthenticated = state => state.isStudentAuthenticated;
export const getErrorMessage = state => state.userPortalError;
export const getSchool = state => state.school;
export const getCartProducts = state => state.products;
export const getClassName = state => state.className;
export const getLanguageName = state => state.lname;
export const getClassId = state => state.classId;
export const getLanguageId = state => state.langId;
export const getSelectedOrderId = state => state.selectedOrderId;
export const getParentSchools = state => state.parentSchools;
export const getHasUniformCatalog = state => state.hasUniformCatalog;